<template>
  <div class="t-video-exercise" v-if="isLoading">
    <div class="t-video-header">
      <img src="../../assets/images/terminal/4.png" class="title-stars" />
      <span class="terminal-title">随堂练习</span>
    </div>
    <div class="t-video-exercise-container" id="question-id">
      <div class="t-left column">
        <img src="../../assets/images/terminal/3.png" class="knowledge-img" />
        <div class="t-knowledge">
          <div class="knowledge-name" v-for="(v, k) in knowledgeList" :key="k">
            {{ v }}
          </div>
        </div>
        <div class="back-button column" @click="onGoBack">返回</div>
      </div>
      <div class="t-center">
        <template v-if="!isSubmit">
          <div class="question-item">
            <div
              class="stem"
              v-html="numHtml(indexIng + 1, dataIng.topic)"
            ></div>
            <div
              class="stem"
              v-html="dataIng.subtitle"
              v-if="dataIng.subtitle"
            ></div>
            <div class="options-box clearfix">
              <div
                class="options"
                v-for="(item, index) in dataIng.option"
                :key="index"
              >
                <div class="o-item" v-html="optionHtml(index, item)"></div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="question-item" v-for="(v, k) in list" :key="k">
            <div class="stem mt10" v-html="numHtml(k + 1, v.topic)"></div>
            <div class="stem mt10" v-html="v.subtitle" v-if="v.subtitle"></div>
            <div class="options-box clearfix">
              <div
                class="options"
                v-for="(item, index) in v.option"
                :key="index"
              >
                <div class="o-item" v-html="optionHtml(index, item)"></div>
              </div>
            </div>
            <div class="clearfix">
              <div class="question-answers m5">
                作答结果：<span
                  v-if="userAnswersList[k] == v.answer"
                  class="success"
                  >对</span
                ><span v-else class="error">错</span>
              </div>
              <div class="question-answers m5">
                您的答案：{{ userAnswersList[k] }}
              </div>
              <div class="question-answers m5">
                正确答案：<span>{{ v.answer }}</span>
              </div>
              <div class="analysis" v-html="v.analysis"></div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="answers active column" v-if="!isSubmit">
      <div
        class="item"
        v-for="(item, index) in answersList"
        :key="index"
        @click="onAnswers(item)"
        :class="{ active: userAnswersList[indexIng] === item }"
      >
        {{ item }}
      </div>
    </div>
  </div>
  <div class="column init-box" v-else>
    <i class="el-icon-loading fs-20"></i>
    <div class="fs-20">正在出题中</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isLoading: false,
      indexIng: 0,
      dataIng: {},
      list: [],
      isSubmit: false,
      listCount: 0,
      answersList: ["A", "B", "C", "D"],
      userAnswersList: [],
      iframeSrc: "",
      userErrorQuestion: [],
      userQuestion: [],
      recommendAliId: "",
    };
  },
  created() {
    this.videoId = this.$route.query.video_id;
    this.count = this.$route.query.count;
    this.uuid = this.$route.query.uuid;
    this.num = this.$route.query.num || 3;
    this.getQuestion();
  },
  methods: {
    getQuestion() {
      this.getRequest("/wenjiaoopne/terminal/question/getVideoQuestionList", {
        video_id: this.videoId,
        count: this.count,
        num: this.num,
      })
        .then((result) => {
          if (result.error_code > 0 || result.data.list.length === 0) {
            this.$message.error("课程对应练习题不足");
            return false;
          }
          this.list = result.data.list;
          this.knowledgeList = result.data.knowledge_list;
          this.recommendAliId = result.data.recommend_ali_id;
          this.listCount = this.list.length;
          this.dataIng = this.list[0];
          this.mathJaxInit();
          this.isLoading = this.listCount > 0;
        })
        .catch(() => {});
    },
    onAnswers(v) {
      if (this.isClick) {
        return false;
      }
      this.isClick = true;
      this.$set(this.userAnswersList, this.indexIng, v);
      let _count = this.listCount - 1;
      setTimeout(() => {
        if (_count > this.indexIng) {
          ++this.indexIng;
          this.dataIng = this.list[this.indexIng];
          this.isClick = false;
        } else {
          this.isSubmit = true;
          this.list.forEach((item, index) => {
            let _result = 1;
            if (item.answer != this.userAnswersList[index]) {
              _result = 0;
              this.userErrorQuestion.push({
                uuid: this.uuid,
                stage_id: item.stage_id,
                subject_id: item.subject_id,
                question_id: item.question_id,
                user_answers: this.userAnswersList[index],
              });
            }
            this.userQuestion.push({
              uuid: this.uuid,
              stage_id: item.stage_id,
              subject_id: item.subject_id,
              grade_id: item.grade_id,
              question_id: item.question_id,
              user_answer: this.userAnswersList[index],
              result: _result,
            });
          });
          this.postRequest("/wenjiaoopne/terminal/question/addUserQuestion", {
            user_question: this.userQuestion,
          }).then(() => {});
        }
        this.mathJaxInit();
      }, 500);
    },
    mathJaxInit() {
      setTimeout(() => {
        this.$nextTick(function() {
          //这里要注意，使用$nextTick等组件数据渲染完之后再调用MathJax渲染方法，要不然会获取不到数据
          if (this.commonsVariable.isMathjaxConfig) {
            //判断是否初始配置，若无则配置。
            this.commonsVariable.initMathjaxConfig();
          }
          this.commonsVariable.MathQueue("question-id"); //传入组件id，让组件被MathJax渲染
        });
      }, 500);
    },
    onGoBack() {
      let _userQuestion = JSON.stringify(this.userErrorQuestion);
      window.location.href = `http://100.canpoint.net/#/terminal/video/exercise?error_question=${_userQuestion}&video_id=${this.recommendAliId}`;
    },
  },
};
</script>
<style scoped>
.t-video-exercise {
  position: relative;
  max-width: 1200px;
  height: 340px;
  margin: 0 auto;
  font-size: 24px;
}
.fs-20 {
  font-size: 24px;
}
.init-box {
  height: 340px;
}
.title-stars {
  width: 56px;
  height: 20px;
  margin-left: 40px;
}
.terminal-title {
  margin-left: 15px;
  color: #ffba0e;
}
.knowledge-img {
  width: 206px;
}
.t-video-header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 39px;
  background-image: url("../../assets/images/terminal/top_1.png");
  background-size: 100% 100%;
  background-position: center center;
  background-repeat: no-repeat;
  z-index: 1;
}
.t-video-exercise-container {
  position: relative;
  width: 100%;
  height: 340px;
}
.t-video-exercise .t-left {
  position: absolute;
  top: 0;
  left: 0;
  width: 26%;
  max-width: 200px;
  height: 340px;
  background-image: url("../../assets/images/terminal/1.png");
}
.t-video-exercise .t-left .t-knowledge {
  height: 150px;
  overflow-y: auto;
}
.t-video-exercise .t-left .knowledge-name {
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 5px 0;
  color: #fff;
}
.t-video-exercise .t-left .subimt {
  margin-top: 10px;
}

.t-video-exercise .t-left .back-button {
  margin-top: 10px;
  width: 85%;
  max-width: 170px;
  height: 45px;
  border-radius: 25px;
  background-color: #ffab33;
  color: #6e3e1b;
  cursor: pointer;
}
.t-video-exercise .is_disabled {
  -moz-opacity: 0.6;
  filter: alpha(opacity=60);
  opacity: 0.6;
}
.t-video-exercise .t-center {
  padding: 45px 45px 0 26%;
  height: 295px;
  overflow-y: auto;
}
.t-video-exercise .question-item {
}
.t-video-exercise .t-center .stem {
  padding: 10px 0 5px 0;
}

.t-video-exercise .t-center .o-item {
  padding: 5px 0 0 10px;
}

.t-video-exercise .t-center .analysis {
  padding: 0 10px;
}
.t-video-exercise .t-center .question-answers {
  padding: 0 10px;
}
.t-video-exercise .answers {
  position: absolute;
  height: 340px;
  top: 0;
  right: 0;
  background: #fff;
}
.t-video-exercise .answers .item {
  width: 35px;
  height: 70px;
  text-align: center;
  line-height: 70px;
  border-radius: 35px 0px 0px 35px;
  background-color: #ffab33;
  margin: 2px 0;
  cursor: pointer;
}
.t-video-exercise .answers .active {
  background-color: #ff7625;
}

.t-video-exercise .mt10 {
  margin-top: 5px;
}
.m5 {
  margin: 2px 0;
}
.t-video-exercise .success {
  color: #67c23a;
}
.t-video-exercise .error {
  color: red;
}
</style>
